export default __webpack_public_path__ + "static/media/SWT0780.34I-19679_-14726_0.c24c2be0.jpg";